import React from 'react';

interface ConfirmStepProps {
  name: string;
  description: string;
  did: string;
  apiEndpoint: string;
  onConfirm: () => void;
  onBack: () => void;
  onCancel: () => void;
}

const ConfirmStep: React.FC<ConfirmStepProps> = ({
  name,
  description,
  did,
  apiEndpoint,
  onConfirm,
  onBack,
  onCancel,
}) => {
  return (
    <div className="card shadow">
      <div className="card-body">
        <h4 className="mb-3">
          <i className="fas fa-check-circle mr-2"></i>
          Review and Confirm
        </h4>

        <p className="text-muted mb-4">
          Review your MPX tenant configuration before creating it.
        </p>

        <div className="alert alert-info mb-4">
          <h6 className="font-weight-bold mb-2">
            <i className="fas fa-cloud mr-2"></i>
            MPX Tenant Details
          </h6>
          
          <div className="mb-2">
            <strong>Tenant Name:</strong>
            <div className="mt-1">{name}</div>
          </div>

          <div className="mb-2">
            <strong>MPX Control Plane DID:</strong>
            <div className="mt-1">
              <code style={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>{did}</code>
            </div>
          </div>

          <div className="mb-2">
            <strong>Resolved API Endpoint:</strong>
            <div className="mt-1">
              <code style={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>{apiEndpoint}</code>
            </div>
          </div>

          {description && (
            <div className="mb-2">
              <strong>Description:</strong>
              <div className="mt-1">{description}</div>
            </div>
          )}

          <div className="mb-0">
            <strong>Status:</strong>
            <div className="mt-1">
              <span className="badge badge-success">ACTIVE</span>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between mt-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onBack}
          >
            <i className="fas fa-arrow-left mr-1"></i> Back
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={onConfirm}
          >
            <i className="fas fa-check mr-1"></i> Create MPX Tenant
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmStep;
